module.exports = __webpack_public_path__ + "img/horizontal_3_7_r_pp123_8019.fd1570c9.png";